import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HorizontalScrollDirective } from './horizontal-scroll.directive';



@NgModule({
    declarations: [
        HorizontalScrollDirective
    ],
    imports: [
        CommonModule
    ],
    exports: [
        HorizontalScrollDirective
    ]
})
export class HorizontalScrollModule { }
